import styled from '@emotion/styled';
import { H3, SmallText, Text } from 'ds/components/typography';
import { ListingCardWrapper as ListCardWrapper } from 'ds/components/ListingCard';


export const IMAGE_HEIGHT = 168;
const MAP_PREVIEW_IMAGE_HEIGHT = 146;
const MAP_PREVIEW_MOBILE_IMAGE_HEIGHT = 217;

export const CardWrapper = styled.div`
  width: 288px;
`;

export const FirstLineLabel = styled(H3.withComponent('h4'))`
${({ theme }) => `
    color: ${theme.colors.brand.dark};
  `}
`;

export const FirstLineLabelH3 = styled(FirstLineLabel.withComponent('h3'))``;

export const SecondLineLabel = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const MapPreviewSecondLineLabel = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const ProjectImageWrapper = styled.div<{ isMapPreview: boolean; }>`
  position: relative;
  ${({ theme, isMapPreview }) => `
    margin-bottom: ${theme.spacing(1.5)};
    height: ${isMapPreview ? MAP_PREVIEW_IMAGE_HEIGHT : IMAGE_HEIGHT}px;
    svg {
      height: 100%;
      width: 100%;
    }
  `}
  ${({ theme, isMapPreview }) => theme.media.showAt({ at: 1 })`
    ${isMapPreview ? `
    height: ${MAP_PREVIEW_MOBILE_IMAGE_HEIGHT}px;
    margin-bottom: ${theme.spacing(1)};
    svg > path:first-of-type {
      fill: transparent;
    }
    ` : ''}
  `}
`;

export const ProjectImage = styled.div<{ isMapPreview: boolean; }>`
  ${({ theme, isMapPreview }) => `
    height: 100%;
    border-radius: ${theme.borderRadius.small} ${theme.borderRadius.small} ${isMapPreview ? '0 0' : `${theme.borderRadius.small} ${theme.borderRadius.small}`};
    background-color: ${theme.colors.neutrals.white};
    overflow: hidden;
    display: flex;
    justify-content: center;

    > img {
      height: 100%;
    }
  `}
`;

export const MarketplaceTypeLabelWrapper = styled.div`
  ${({ theme }) => `
    margin-top: -${theme.spacing(1.25)};
  `}
`;

export const MapPreviewBody = styled.div<{ isMapPreview: boolean; isIOS?: boolean; }>`
  ${({ theme }) => `
    padding: 0 ${theme.spacing(1)};
  `};
  ${({ isMapPreview }) => isMapPreview ? `
    min-height: 123px;
  ` : ''}
  ${({ theme, isMapPreview, isIOS }) => theme.media.showAt({ at: 1 })`
    padding: 0 ${theme.spacing(3)};
    ${isMapPreview && isIOS ? `
      margin-bottom: ${theme.spacing(3)};
    ` : ''}
  `}
`;

export const ListingCardWrapper = styled(ListCardWrapper)`
  min-height: 322px;

  ${({ theme }) => `
    border: 1px solid ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.small};
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    border: 1px solid ${theme.colors.neutrals.grey9};
    box-shadow: 0px 2px 4px rgba(155, 155, 155, 0.1);
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    &:hover {
      box-shadow: 0px 2px 4px rgba(155, 155, 155, 0.1);
      border: 1px solid ${theme.colors.neutrals.grey9};
    }
  `}
`;
